module.exports = __webpack_public_path__ + "img/sustain.e2bafc32.svg";